import React, {useContext, useState, useEffect, useMemo } from 'react';
import styles from './PermissionTable.module.css';
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {PageAuthRegisterModal} from "../modal/PageAuthRegisterModal";
import DetailModal from "../../../utils/modal/DetailModal";
import { InnocodeButton, InnocodeDatatable, useModal } from '@intsoft/innocode-core';
import PermissionEditModal from './PermissionEditModal';

const PermissionTable = ({ permissions, onPermissionChange, handleAddPermission, onReload}) => {
  const {openModal} = useContext(ModalContext);
  const { showInnocodeModal } = useModal();
  // const [localPermissions, setLocalPermissions] = useState(permissions);

  // useEffect(() => {
  //   setLocalPermissions(permissions);
  // }, [permissions]);

  const handleCheckboxChange = (index, field) => {
    const updated = [...permissions];
    updated[index][field] = !updated[index][field];
    // setLocalPermissions(updated);
    onPermissionChange(updated); // ✅ 부모에게 알림
  };


  const columns = useMemo(() => {
    const baseColumns = [
      {
        id: 'authorityName',
        header: '권한 명',
        accessorKey: 'authorityName',
        enableSorting: true,
        align: 'center',
        cell: ({ row }) => <span>{row.authorityName}</span>,
      },
      {
        id: 'create',
        header: '쓰기',
        accessorKey: 'create',
        enableSorting: true,
        align: 'center',
        cell: ({ row }) => <span>{row.create ? 'Y' : 'N'}</span>,
      },
      {
        id: 'read',
        header: '읽기',
        accessorKey: 'read',
        enableSorting: false,
        align: 'center',
        cell: ({ row }) => <span>{row.read ? 'Y' : 'N'}</span>,
      },
      {
        id: 'update',
        header: '수정',
        accessorKey: 'update',
        enableSorting: false,
        align: 'center',
        cell: ({ row }) => <span>{row.update ? 'Y' : 'N'}</span>,
      },
      {
        id: 'delete',
        header: '삭제',
        accessorKey: 'delete',
        enableSorting: false,
        align: 'center',
        cell: ({ row }) => <span>{row.delete ? 'Y' : 'N'}</span>,
      },
      // {
      //   id: 'setting',
      //   header: '',
      //   accessorKey: '',
      //   enableSorting: false,
      //   align: 'center',
      //   cell: ({ row }) => <InnocodeButton 
      //   theme={"opacity"}
      //   designType={"assistive"}
      //   size={"xs"} 
      //   iconOnly={true} icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      //     <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"/>
      //     <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
      //   </svg>
      //   }/>,
      // },
    ];
 
    return baseColumns;
  }, [permissions]);

  const handleRowClick = (row) => {
    console.log('Selected permission:', row);
    showInnocodeModal({
        enableDefaultStyle: true,
        enableMobileFullScreen: false,
        headerBuilder: () => { return <></>; },
        contentBuilder: (
            _data,
            _handleSave,
            _handleDelete,
            _handleUpdate,
            handleClose,
            _modalType
        ) => {
            return <PermissionEditModal
                permission={row}
                onClose={handleClose}
                onSave={onReload}
            />;
        },
    });
  };

  return (
    <div className={styles.permissionWrapper}> 
    <InnocodeDatatable
        className={styles.dataTable}
        data={permissions}
        columns={columns}
        enableCustomHeader={true}
        customHeader={
          <div className={styles.customHeaderContainer}>
            <div className={styles.customHeaderSearchContainer}>
                
            </div>
            <div className={styles.customHeaderActionContainer}>
              <InnocodeButton
                designType="primary"
                theme="line"
                size="md"
                onClick={handleAddPermission}
              >
                페이지 권한 추가
              </InnocodeButton>
            </div>
          </div>
        }
        enableTableHeader={true}
        enableSorting={true}
        enableCheckbox={false}
        enablePagination={false}
        pageSize={permissions.length}
        totalCount={permissions.length}
        currentPage={1}
        emptyMessage="페이지 목록이 없습니다."
        rowClassName={styles.tableRow}
        onRowClick={handleRowClick}
      />
      {/* <div className={styles.roleWrapper}>
        <div className={styles.roleSection}>
          <div className={styles.sectionTitle}>권한 리스트</div>
          {permissions.map((auth, idx) => (
            <div key={idx} className={styles.roleItem}>{auth.authorityName}</div>
          ))}
        </div>
        <div className={styles.roleButtons}>
          <button className={styles.actionButton} onClick={handleAddPermission}>페이지 권한 추가</button>
        </div>
      </div>
 
      <div className={styles.matrixWrapper}>
        <div className={styles.matrixSection}>
          <div className={styles.headerRow}>
            <div>쓰기</div>
            <div>읽기</div>
            <div>수정</div>
            <div>삭제</div>
          </div>
          {permissions.map((auth, idx) => (
            <div key={idx} className={styles.permissionRow}>
              {['create', 'read', 'update', 'delete'].map((field) => (
                <input
                  key={field}
                  type="checkbox"
                  checked={auth[field]}
                  onChange={() => handleCheckboxChange(idx, field)}
                  className={styles.permissionCheckbox}
                />
              ))}
            </div>
          ))}
        </div>
        <div className={styles.matrixButtons}>
          <InnocodeButton 
            size="sm"
            theme="filled"
            designType="primary"
            onClick={handleSavePermission}
          >
            권한 저장
          </InnocodeButton>
        </div>
      </div> */}
    </div>
  );
};

export default PermissionTable;
